/**
 * Are we running inside react-snap's prerender crawl?
 *
 * react-snap loads every route in a headless browser and saves the resulting
 * DOM as the static HTML that visitors are served. Anything a component decides
 * to show during that crawl gets BAKED INTO THE SNAPSHOT — and for a modal that
 * is not merely wrong, it is fatal:
 *
 *   A dialog portalled to document.body is captured as a SIBLING of #root. On
 *   the next visit the browser paints it from the static HTML, React mounts
 *   INSIDE #root, and React has no knowledge of that stray element — so it
 *   never removes it and never attaches a handler to it. The result is a
 *   full-screen, top-of-stack overlay with no working controls: the page is
 *   locked and even the close button is dead.
 *
 * So any client-only, transient UI must check this before it opens.
 */
export const isPrerender = (): boolean =>
  typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";
